module.exports = __webpack_public_path__ + "img/chest-top.89519e6e.svg";